import { Icon } from '@iconify/react'
import { PRICES } from 'src/lib/constants'
import Mixpanel from 'src/lib/mixpanel'
import { ModalHeader, ModalBody, Button, Modal, ModalContent } from '@nextui-org/react'
import React, { useEffect, useState } from 'react'
import api from 'src/lib/api'
import { useSubscriptionContext } from 'src/context/subscription'
import { useSocketContextData } from 'src/context/socket'
import { useNavigate } from 'react-router-dom'
import { PowerDocsEventsName } from 'src/types/SocketEvents'
import toast from 'react-hot-toast'
interface SubscribeLimitDocumentProps {
  onClose: () => void
  isOpen: boolean
}
export function SubscribeLimitDocument({ onClose, isOpen }: SubscribeLimitDocumentProps) {
  const [profile, setPorfile] = useState<any>({})

  const loadUser = () => {
    const userString = localStorage.getItem('user')
    if (userString) {
      setPorfile(JSON.parse(userString))
    }
    api
      .get('/agencies/profile')
      .then((res) => {
        localStorage.setItem('user', JSON.stringify(res.data))
        setPorfile(res.data)
      })
      .catch((e) => {
        console.log('Error loading current profile')
      })
  }
  const {currentLimitations} = useSubscriptionContext()
  const [loading, setLoading] = useState<boolean>(false)
  const { io } = useSocketContextData()
  const navigate = useNavigate()
  const subscribeTo = async (product: 'EXPLORE' | 'EVALUATE' | 'EXECUTE') => {
      setLoading(true)
      const subscribed = await io.emitWithAck(PowerDocsEventsName.SELECT_FREE_TIER, {
          product,
          token: localStorage.getItem('accessToken'),
      })
      if (subscribed) {
        loadUser()

        toast.success(`🎉 Yaaay! Your plan has been upgraded to ${product}`)
        setLoading(false)
      }
      setLoading(false)
  }
  useEffect(() => {
    loadUser()
  }, [])
  return (
    <Modal
      className={'no-scrollbar'}
      backdrop="blur"
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      size="4xl"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1"></ModalHeader>
            <ModalBody className={'scrollbar-hide px-2 md:px-20 pb-20 pt-10 gap-0'}>
              <div
                className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded mb-5"
                role="alert"
              >
                <p className="font-bold">{currentLimitations && currentLimitations.isFreeTrial ? 'Upgrade Required' : ''}</p>
                <p>This feature is only available for people with 'EXECUTE' subscription, would you like to upgrade your subscription from <b>{currentLimitations?.currentSubscription}</b> to <b>EXECUTE</b>.</p>
              </div>
              <h2 className={'text-xl  text-center text-secondary uppercase'}>Pricing</h2>
              <h1 className={'text-4xl  text-center mb-4 font-bold'}>Pricing made easy</h1>
              <p className={'text-sm text-default-400 w-full text-center mb-4'}>
                Flexible plans designed for everyone, offering simplicity and convenience
              </p>
              <div className={'flex flex-row gap-4'}>
                {
                  currentLimitations && currentLimitations.currentSubscription === 'EXPLORE' && (
                    <div className={'flex flex-col flex-1 border border-3 rounded-2xl border-default p-4'}>
                    <span className={'text-xs font-bold text-default-400 pb-2'}>EXPLORE</span>
                    <h3 className={'text text-3xl font-bold'}>$ 29</h3>
                    <h4 className={'text text-l font-bold'}>per user per month</h4>
                    <span className={'font-medium text-default-400 text-xs pb-4'}>Free 1-week trial, cancel anytime</span>

                    <span className={'font-medium text-sm'}>Monitor tenders</span>
                    <ul className="list-inside list-none text-md font-light text-black pb-2">
                        <li className={'flex flex-row items-center gap-1 mb-1'}>
                            <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                        </li>
                        <li className={'flex flex-row items-center gap-1 mb-1'}>
                            <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                        </li>
                    </ul>
                    <hr className='w-[80%] self-center' />
                    <span className={'font-medium text-sm pt-2'}>Analyze fit & risks</span>
                    <ul className="list-inside list-none text-md font-light text-black pb-2">
                        <li className={'flex flex-row items-center gap-1 mb-1'}>
                            <Icon className={'text-default'} icon="lucide:x" /> AI tender monitoring
                        </li>
                        <li className={'flex flex-row items-center gap-1 mb-1'}>
                            <Icon className={'text-default'} icon="lucide:x" /> Automatic email notifications
                        </li>
                    </ul>
                    <hr className='w-[80%] self-center' />
                    <span className={'font-medium text-sm pt-2'}>Create & manage proposals</span>
                    <ul className="list-inside list-none text-md font-light text-black pb-2">
                        <li className={'flex flex-row items-center gap-1 mb-1'}>
                            <Icon className={'text-default'} icon="lucide:x" /> AI-assisted proposal drafting
                        </li>
                        <li className={'flex flex-row items-center gap-1 mb-1'}>
                            <Icon className={'text-default'} icon="lucide:x" /> Microsoft Word integrationm
                        </li>
                        <li className={'flex flex-row items-center gap-1 mb-1'}>
                            <Icon className={'text-default'} icon="lucide:x" /> Team workspace & audit logs
                        </li>
                    </ul>

                    <Button
                        onClick={() => {
                            // Track payment intent
                            onClose?.()
                        }}
                        variant={'bordered'}
                        className={'rounded-3xl font-bold text-sm w-fit pl-10 pr-10 self-center mt-4'}
                        color={'secondary'}
                    >
                        Keep My Plan
                    </Button>
                </div>
                  )
                }
                 {
                  currentLimitations && currentLimitations.currentSubscription === 'EVALUATE' && (
                   
                    <div className={'flex flex-col flex-1 border border-3 rounded-2xl border-default p-4'}>
                        <span className={'text-xs font-bold text-default-400 pb-2'}>EVALUATE</span>
                        <h3 className={'text text-3xl font-bold'}>$ 59</h3>
                        <h4 className={'text text-l font-bold'}>per user per month</h4>
                        <span className={'font-medium text-default-400 text-xs pb-4'}>Free 1-week trial, cancel anytime</span>

                        <span className={'font-medium text-sm'}>Monitor tenders</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Analyze fit & risks</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Create & manage proposals</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> AI-assisted proposal drafting
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> Microsoft Word integrationm
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> Team workspace & audit logs
                            </li>
                        </ul>

                        <Button
                        onClick={() => {
                            // Track payment intent
                            onClose?.()
                        }}
                        variant={'bordered'}
                        className={'rounded-3xl font-bold text-sm w-fit pl-10 pr-10 self-center mt-4'}
                        color={'secondary'}
                    >
                        Keep My Plan
                    </Button>
                    </div>

                  )
                }
                
                <div className={'flex flex-col flex-1 border border-3 rounded-2xl border-secondary p-4'}>
                        <span className={'text-xs font-bold text-default-400 pb-2'}>EXECUTE</span>
                        <h3 className={'text text-3xl font-bold'}>$ 99</h3>
                        <h4 className={'text text-l font-bold'}>per user per month</h4>
                        <span className={'font-medium text-default-400 text-xs pb-4'}>Free 1-week trial, cancel anytime</span>

                        <span className={'font-medium text-sm'}>Monitor tenders</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Analyze fit & risks</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Create & manage proposals</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI-assisted proposal drafting
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Microsoft Word integrationm
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Team workspace & audit logs
                            </li>
                        </ul>

                        <Button
                            onClick={() => {
                                // Track payment intent
                                subscribeTo('EXECUTE')
                            }}
                            variant={'solid'}
                            className={'rounded-3xl font-bold text-sm w-fit pl-10 pr-10 self-center mt-4'}
                            color={'secondary'}
                            isDisabled={loading}
                        >
                            Get Started
                        </Button>
                    </div>
              </div>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}
